import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import MacroeconomicsProxy from './proxy'

class MacroeconomicsService extends ServiceBase {
  exportMacroeconomics(params) {
    return this.getFileDownload(() =>
      MacroeconomicsProxy.exportMacroeconomics(params),
    )
  }
}

export default new MacroeconomicsService()
